import apis from '@/apis';
import defaultEntireData from '@/pages/data-panel/components/entire-data/default-data';
import { RESET_DATA_PANEL } from './constants';
import { FETCH_QUERYCONDITIONS_INFO } from './filter-box';
export const QUERY_ACTIVITY_PLAN = 'QUERY_ACTIVITY_PLAN';
export const HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA = 'haveRightToViewActivityData';
export const QUERY_ACTIVITY_LOADING = 'QUERY_ACTIVITY_LOADING';
export const RESET_PLAN_DATA = 'RESET_PLAN_DATA';
export const queryActivityPlanDataAll = (data) => (dispatch, getState) => {
  // const { startTime, endTime } = data
  dispatch({
    type: QUERY_ACTIVITY_LOADING,
    payload: true,
  });
  const param = Object.assign(
    {},
    { startTime: data.startTime },
    { endTime: data.endTime },
    { plant: data.channel },
    { planCode: data.activityCode }
  );
  apis.queryActivityPlanDataAll(param).then((res) => {
    if (res && res.ret === '0') {
      // res.data.viewClick.push({}, {})
      // res.data.viewClick = res.data.viewClick.slice(0, 9)
      res.data && res.data.viewClick && res.data.viewClick.push({});
      dispatch({
        type: QUERY_ACTIVITY_PLAN,
        payload: res.data,
      });
    } else {
      dispatch({
        type: QUERY_ACTIVITY_PLAN,
        payload: {},
      });
    }
    if (res && res.ret === '9') {
      dispatch(haveRightToViewActivityData());
    }
  });
};

export const resetPlanData = function () {
  return {
    type: 'RESET_PLAN_DATA',
  };
};
export const haveRightToViewActivityData = function (payload) {
  return {
    type: HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA,
    payload,
  };
};

const initialState = {
  // 是否有查看当前活动的权限
  haveRightToViewActivityData: true,
  viewClick: defaultEntireData.inActivityData.viewClick,
  rebuyInfo: defaultEntireData.inActivityData.rebuyInfo,
  dealTrans: defaultEntireData.inActivityData.dealTrans,
  flowEfficiency: defaultEntireData.inActivityData.flowEfficiency,
  activityPlanDataDetailList: [],
  saleTarget: 0,
  realSale: '',
  completeRate: 0,
  loading: false,
  downloadUrl: '',
};

export default function activityPlan(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case QUERY_ACTIVITY_PLAN:
      return Object.assign({}, state, payload, {
        loading: false,
      });
    case HAVE_RIGHT_TO_VIEW_ACTIVITY_DATA:
      return Object.assign({}, state, { haveRightToViewActivityData: payload });
    case RESET_DATA_PANEL:
      return initialState;
    case FETCH_QUERYCONDITIONS_INFO:
      // 切换活动查询则重置权限
      return initialState;
    case RESET_PLAN_DATA:
      return initialState;
    case QUERY_ACTIVITY_LOADING:
      return Object.assign({}, state, payload);
    default:
      return state;
  }
}
